// extracted by mini-css-extract-plugin
export default {"loader":"center-loader_loader__+QGru","centered":"center-loader_centered__oYPYA"};